import { render, staticRenderFns } from "./BanKDetails.vue?vue&type=template&id=88935b90"
import script from "./BanKDetails.vue?vue&type=script&lang=js"
export * from "./BanKDetails.vue?vue&type=script&lang=js"
import style0 from "./BanKDetails.vue?vue&type=style&index=0&id=88935b90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports